import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "message-modal",
  templateUrl: "./message-modal.component.html",
  styleUrls: ["./message-modal.component.scss"]
})
export class MessageModalComponent implements OnInit {
  @Input() title: string;
  @Input() content: string;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}

  exit() {
    this.activeModal.close(false);
  }
}
